import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import GameTable from "./GameTable";
import { setNavItem } from "../../../utils/localStorage";
import "./Game.scss";
import { Tabs } from "antd";
import PastGameTable from "./PastGameTable/PastGameTable";
import { FilledButton } from "../../commonComponents";
import UnsupportedCurrency from "../../modals/UnsupportedCurrency/UnsupportedCurrency";
import {
  isJoinBlockedByCurrency,
  logCurrencyBlock,
} from "../../../helpers/walletCurrency";

const Game = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [isUnsupportedCurrencyOpen, setIsUnsupportedCurrencyOpen] =
    useState(false);
  const navigate = useNavigate();

  const tabItems = useMemo(() => [
    {
      label: "Upcoming",
      key: "1",
      children: <GameTable className="game-table" />, // Ensure class is applied
    },
    {
      label: "Started",
      key: "2",
      children: <PastGameTable className="game-table" />, // Ensure class is applied
    },
  ], []);

  useEffect(() => {
    setNavItem(1);
  }, []);

  // Tell a non-USD player when they land, not after they have picked teams.
  // The submit-time guards in both ExpandedDetails remain as the backstop -
  // this modal is dismissable and browsing stays open, so the join path still
  // has to defend itself.
  useEffect(() => {
    if (isJoinBlockedByCurrency()) {
      logCurrencyBlock("game-page-mount");
      setIsUnsupportedCurrencyOpen(true);
    }
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  // Cross-page anchor link: Home.jsx owns the actual "How To Play" section
  // (id="how-to-play") and, on mount, scrolls to it whenever the URL hash
  // matches — see the location.hash effect there.
  const handleHowToPlayButton = () => {
    setNavItem(0);
    navigate("/#how-to-play");
  };

  return (
    <div className="game white-color">
      <UnsupportedCurrency
        visible={isUnsupportedCurrencyOpen}
        closeModal={() => setIsUnsupportedCurrencyOpen(false)}
      />
      <div className="text-center">
        <div className="main-padding">
          <div className="game-join-action font-cairo-medium primary-color">
            JOIN THE ACTION NOW!
          </div>
          <div className="game-heading font-cairo-extrabold">
            Unleash Your Strategy & Become The Ultimate Champion!
          </div>
        </div>
        <div>
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            items={tabItems}
            className="game-info-cont-tab"
            animated={false}
            destroyInactiveTabPane={true}
          />
        </div>
        <div className="game-button">
          <FilledButton
            name={"How To Play"}
            btnClass="primary-background home-buttons-read-all"
            type={1}
            functionCall={handleHowToPlayButton}
          />
        </div>
        {/* <div className="game-button">
          <FilledButton
            name={"Create a Private Game"}
            link={"/privategame"}
            btnClass="primary-background"
            type={1}
            functionCall={CheckUserExcluded}
          />
        </div> */}
      </div>
    </div>
  );
};

export default Game;
